import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { openModal, closeModal } from '../../features/modalSlice';
import { parseJwt, mobileAndTabletCheck } from '../../app/utils';
import { ModalType } from '../../app/types';

const useStyles = makeStyles(
  {
    root: {
      textAlign: 'center',
      marginTop: 'calc(100vh - 105px)',
    },
    back: {
      display: 'inline-block',
      padding: '4px 20px',
      borderRadius: '500px',
      border: 'solid 1px #88c029',
      marginBottom: 36,
      fontSize: '15px',
      fontWeight: '500',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      color: '#88c029',
      cursor: 'pointer',
    },
    text: {
      fontSize: '15px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      marginBottom: 12,
    },
  },
  {
    name: 'LiffRedirect',
  },
);

const LiffRedirectContainer = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const classes = useStyles();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const token = query.get('access_token') || '';
  const { lineLiffId, lineAccountId } = parseJwt(token) || {};

  const closeWindow = () => {
    if (lineAccountId) {
      window.location.href = `https://line.me/R/ti/p/${lineAccountId}`;
    } else {
      dispatch(
        openModal({
          modalType: ModalType.AWARD_MODAL,
          modalProps: {
            content: t('liff-redirect-msg'),
            onClick: () => {
              dispatch(closeModal());
            },
            submitText: t('ok'),
          },
        }),
      );
    }
  };

  useEffect(() => {
    if (mobileAndTabletCheck()) {
      window.location.href = `line://app/${lineLiffId}${location.search}`;
    } else {
      window.location.href = `https://liff.line.me/${lineLiffId}${location.search}`;
    }
  }, []);

  return (
    <div className={classes.root}>
      <div className={classes.back} onClick={closeWindow}>
        {t('back-to-line')}
      </div>
      <div className={classes.text}>{t('made-super-8')}</div>
    </div>
  );
};

export default LiffRedirectContainer;
